var map = {
	"./decidim/avatar-multiuser.png": 97237,
	"./decidim/brands/facebook.svg": 67793,
	"./decidim/brands/google.svg": 99272,
	"./decidim/brands/twitter-x.svg": 91949,
	"./decidim/cc-badge.png": 17555,
	"./decidim/decidim-logo.svg": 85367,
	"./decidim/default-avatar.svg": 11899,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 51697,
	"./decidim/icons.svg": 2666,
	"./decidim/pattern.png": 9913,
	"./decidim/placeholder-card-g.svg": 84502,
	"./decidim/placeholder-card-l.svg": 87165,
	"./decidim/placeholder.jpg": 63164,
	"./decidim/remixicon.symbol.svg": 23118,
	"./decidim/vendor/social-share-button/douban.svg": 80305,
	"./decidim/vendor/social-share-button/email.svg": 3506,
	"./decidim/vendor/social-share-button/facebook.svg": 30746,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 13718,
	"./decidim/vendor/social-share-button/hacker_news.svg": 71746,
	"./decidim/vendor/social-share-button/linkedin.svg": 85312,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 73593,
	"./decidim/vendor/social-share-button/pinterest.svg": 46956,
	"./decidim/vendor/social-share-button/reddit.svg": 84518,
	"./decidim/vendor/social-share-button/telegram.svg": 98199,
	"./decidim/vendor/social-share-button/tumblr.svg": 78676,
	"./decidim/vendor/social-share-button/twitter.svg": 84839,
	"./decidim/vendor/social-share-button/vkontakte.svg": 45077,
	"./decidim/vendor/social-share-button/wechat.svg": 66968,
	"./decidim/vendor/social-share-button/whatsapp.svg": 6136,
	"./decidim/vendor/social-share-button/x.svg": 94642,
	"./decidim/vendor/social-share-button/xing.svg": 90198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28560;